import { hasValue } from 'swipeclock-frontend';

const SUCCESS_SCREEN_NAMES = Object.freeze({
  PunchIn: 'ONTIMEIN_SUCCESS',
  PunchOut: 'ONTIMEOUT_SUCCESS',
  StartBreak: 'OUTBREAK_SUCCESS',
  EndBreak: 'INBREAK_SUCCESS',
  StartMeal: 'OUTMEAL_SUCCESS',
  EndMeal: 'INMEAL_SUCCESS',
  Transfer: 'TRANSFER',
});

const WARNING_SCREEN_NAMES = new Set([
  'EARLYIN_SUCCESS',
  'EARLYOUT_SUCCESS',
  'LATEIN_SUCCESS',
  'LATEOUT_SUCCESS',
]);

export const OFFLINE_SAVE_FAILURE_ROUTE =
  '/clock/web/pop-ups/punch/alert/failure';
export const OFFLINE_SAVE_SUCCESS_ROUTE =
  '/clock/web/pop-ups/punch/alert/success';
export const OFFLINE_SAVE_WARNING_ROUTE =
  '/clock/web/pop-ups/punch/alert/warning';

export const OFFLINE_SAVE_FAILURE_MESSAGE =
  'Unable to save your punch offline. Please try again or contact your administrator.';

export function getOfflineSuccessScreenName(punch) {
  return SUCCESS_SCREEN_NAMES[punch] || 'ONTIMEIN_SUCCESS';
}

const isWarningScreenName = (screenName) =>
  hasValue(screenName) && WARNING_SCREEN_NAMES.has(screenName);

export function buildOfflineSaveNavigation({
  punch,
  requestType,
  punchResult,
  errorRouting,
}) {
  const warningScreenName = punchResult?.screenName || errorRouting?.screenName;

  if (
    errorRouting?.route?.includes('warning') ||
    isWarningScreenName(warningScreenName)
  ) {
    return {
      route: OFFLINE_SAVE_WARNING_ROUTE,
      routeData: {
        punch,
        punchType: punch,
        requestType,
        warning: errorRouting?.message,
        ...(errorRouting?.title && { title: errorRouting.title }),
        ...(isWarningScreenName(warningScreenName) && {
          punchResult: { screenName: warningScreenName },
        }),
      },
    };
  }

  const screenName =
    punchResult?.screenName && !isWarningScreenName(punchResult.screenName)
      ? punchResult.screenName
      : getOfflineSuccessScreenName(punch);

  return {
    route: OFFLINE_SAVE_SUCCESS_ROUTE,
    routeData: {
      punch,
      punchType: punch,
      requestType,
      punchResult: { screenName },
    },
  };
}

export function buildOfflineSaveFailureNavigation({
  punch,
  message = OFFLINE_SAVE_FAILURE_MESSAGE,
}) {
  return {
    route: OFFLINE_SAVE_FAILURE_ROUTE,
    routeData: {
      punch,
      punchType: punch,
      requestType: 'punch-error',
      error: message,
    },
  };
}

export function routeAfterOfflineSave({ setRouteData, ...options }) {
  const { route, routeData } = buildOfflineSaveNavigation(options);
  setRouteData(routeData);
  return route;
}

export function routeAfterOfflineSaveFailure({ setRouteData, ...options }) {
  const { route, routeData } = buildOfflineSaveFailureNavigation(options);
  setRouteData(routeData);
  return route;
}

/**
 * Merge status-page fields into webClock temp without replacing existing keys
 * such as clockPrompts. PromptSuccess reads top-level screenName from temp.
 */
export function applyOfflineRouteData(addToTemp, routeData) {
  const screenName = routeData?.punchResult?.screenName;
  addToTemp({
    ...routeData,
    ...(hasValue(screenName) && { screenName }),
  });
}
